import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BusinessSummary } from '../models/business-summary.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { getAwardName, getBadgeImageUrl, getCurrentFteAwardTags, getHistoricalFteAwardTags, hasTag } from '../../util/tag-utils';
import { ReportCardPdfService } from '../../shared/services/report-card-pdf.service';
var BusinessSummaryComponent = /** @class */ (function () {
    function BusinessSummaryComponent(businessManagerService, reportCardPdfService) {
        this.businessManagerService = businessManagerService;
        this.reportCardPdfService = reportCardPdfService;
        this.isFlightDeckAdmin = false;
        this.displayReportCard = false;
        this.displayHistoricalBadges = false;
    }
    BusinessSummaryComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        this.displayHistoricalBadges = hasTag(this.business.fteAwardTags, 'Admin::Flight Training::Display Prior Year Badges');
                        this.displayReportCard = hasTag(this.business.fteAwardTags, 'Admin::Flight Training::Display Customer Feedback Report');
                        // remove control tags from the list
                        this.business.fteAwardTags = this.business.fteAwardTags.filter(function (t) { return t.tagName.includes('Awards::Flight Training::'); });
                        if (this.displayHistoricalBadges) {
                            this.tagsToDisplay = getCurrentFteAwardTags(this.business.fteAwardTags);
                            this.oldTagsToDisplay = getHistoricalFteAwardTags(this.business.fteAwardTags);
                        }
                        else {
                            this.tagsToDisplay = getCurrentFteAwardTags(this.business.fteAwardTags);
                            this.oldTagsToDisplay = [];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BusinessSummaryComponent.prototype, "hasServices", {
        get: function () {
            return this.business && (this.business.maintenance
                || this.business.rental.planes
                || this.business.rental.rotorcraft
                || this.business.rental.cars
                || this.business.rental.equipment
                || this.business.sales
                || this.business.flightTraining
                || this.business.fuel.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessSummaryComponent.prototype, "listingBackground", {
        get: function () {
            if (this.isFlightDeckAdmin && this.business.hideBusiness) {
                return 'not-ok';
            }
            else if (this.isFlightDeckAdmin && this.business.notApproved) {
                return 'not-approved';
            }
            else {
                return 'business-summary';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessSummaryComponent.prototype, "fboFees", {
        /**
         * Returns fees that are applicable to this FBO.
         */
        get: function () {
            var result = [];
            if (this.business.isFbo) {
                var hasOther = false;
                var feesWanted = ['Ramp', 'Hangar', 'Tie Down', 'Landing', 'Overnight', 'Handling', 'Parking'];
                if (this.business.feeTypes != null) {
                    for (var _i = 0, _a = this.business.feeTypes; _i < _a.length; _i++) {
                        var busFee = _a[_i];
                        for (var _b = 0, feesWanted_1 = feesWanted; _b < feesWanted_1.length; _b++) {
                            var currentFee = feesWanted_1[_b];
                            if (busFee === currentFee) {
                                result.push(busFee);
                            }
                            else {
                                hasOther = true;
                            }
                        }
                    }
                }
                //  Filters array by uniqueness
                result = result.filter(function (value, i, self) { return self.indexOf(value) === i; }).sort();
                if (hasOther) {
                    result.push('Other');
                }
            }
            return result.join(', ');
        },
        enumerable: true,
        configurable: true
    });
    BusinessSummaryComponent.prototype.getAwardName = function (tagName) {
        return getAwardName(tagName);
    };
    BusinessSummaryComponent.prototype.getBadgeImageUrl = function (tagName) {
        return getBadgeImageUrl(tagName);
    };
    BusinessSummaryComponent.prototype.clickReportCard = function () {
        this.reportCardPdfService.getReportCardPdf(this.business.id, this.fteAwardYear).subscribe(function (res) {
            var fileURL = URL.createObjectURL(res);
            window.open(fileURL, '_blank');
        });
    };
    BusinessSummaryComponent.prototype.getReportCardBadgeUrl = function () {
        return 'https://www.aopa.org/-/media/Images/passport/2023/FTSurvey/2206_Flight_School_Report_Card%20Badge_400x400';
    };
    return BusinessSummaryComponent;
}());
export { BusinessSummaryComponent };
